// Modern theme object for Knoowl (replacing Minecraft theme)
const modernTheme = {
  light: {
    fontFamily: "'Baloo 2', cursive",
    fontUrl: "https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap",
    background: "#fff",
    backgroundSize: 'auto',
    appHeaderBg: '#fff',
    appHeaderColor: '#111',
    appLink: '#111',
    boxShadow: '0 4px 12px 0 rgba(0,0,0,0.06)',
    buttonBg: '#111',
    buttonColor: '#fff',
    cardBg: '#fff',
    cardText: '#111',
    textColor: '#111',
    borderColor: '#e5e7eb',
  },
  dark: {
  fontFamily: "'Baloo 2', cursive",
  fontUrl: "https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap",
    background: "#111",
  backgroundSize: 'auto',
    appHeaderBg: '#111',
    appHeaderColor: '#fff',
    appLink: '#fff',
    boxShadow: '0 4px 12px 0 rgba(0,0,0,0.24)',
    buttonBg: '#fff',
    buttonColor: '#111',
    cardBg: '#18181b',
    cardText: '#fff',
    textColor: '#fff',
    borderColor: '#333',
  },
};

export default modernTheme; 